export default __webpack_public_path__ + "static/media/tower_logo.f4bd197b.svg";